import { Mail, Lock } from 'lucide-react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="flex  flex-col md:grid md:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="flex items-center justify-start">
              <Link href="/">
                <img src="/businesswallet-light.svg" alt="BusinessWallet" className='w-16' />
                <span className="text-xl font-bold">BusinessWallet.eu</span>
              </Link>
            </div>
            <p className="text-slate-400">
              The future of secure digital identity for EU businesses.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://www.linkedin.com/company/businesswallet" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                <span className="sr-only">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
            </div>
          </div>

          {/* REMOVE COL START WHEN WE HAVE THIRD LIST */}
          <div className='col-start-3'>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Product
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/features" className="text-slate-400 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link href="/features#security" className="text-slate-400 hover:text-white transition-colors">
                  Security
                </Link>
              </li>
              <li>
                <Link href="/features#integration" className="text-slate-400 hover:text-white transition-colors">
                  Integration
                </Link>
              </li>
              <li>
                <Link href="/early-access" className="text-slate-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Company
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/about" className="text-slate-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link href="/blog" className="text-slate-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link href="/about#careers" className="text-slate-400 hover:text-white transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link href="/about#contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* <div>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Legal
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/privacy-policy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms-of-service" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/cookie-policy" className="text-slate-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link href="/gdpr" className="text-slate-400 hover:text-white transition-colors">
                  GDPR Compliance
                </Link>
              </li>
            </ul>
          </div> */}
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-slate-400 text-sm space-y-2">
              <p>© 2025 BusinessWallet.eu. All rights reserved.</p>
              <p>Not affiliated with or endorsed by the European Union or any EU institution.</p>
            </div>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <a href="mailto:contact@websloth.agency" className="text-slate-400 hover:text-white transition-colors text-sm">
                <span className="flex items-center">
                  <Mail className="w-4 h-4 mr-2" />
                  contact@websloth.agency
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 